// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1TIGM","header":"Messages_header__2gsQX"};